// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"615":"e179cd86","661":"d3f541cc","750":"e179cd86"}[chunkId] + ".chunk.css";
};